<template>
    <li>
        <AtomsTitle3D
            class="text-base-white"
            :id="`slt-js-milestone-title-${index}`"
        >
            <span
                class="text-primary-orange"
                v-if="shouldRender(milestone.name)"
            >
                {{ milestone.name }}
            </span>
            <span v-if="shouldRender(milestone.title)">
                {{ milestone.title }}
            </span>
        </AtomsTitle3D>

        <div
            class="flex max-w-[285px] flex-col gap-3 sm:max-w-[378px] sm:gap-[14px] lg:max-w-[409px] lg:gap-4"
            :id="`slt-js-milestone-event-${index}-${idx}`"
            v-for="(e, idx) in milestone.events"
            :key="idx"
        >
            <AtomsH2
                class="text-left text-base-white"
                lang="en"
                v-if="shouldRender(e.time)"
            >
                {{ `${e.time}’` }}
            </AtomsH2>
            <div class="flex flex-col gap-3 sm:gap-[14px] lg:gap-4">
                <div
                    v-for="(c, idx2) in e.contents"
                    :key="idx2"
                    class="flex gap-1 pl-4 sm:pl-5"
                >
                    <span
                        class="flex h-[19.2px] w-auto items-center sm:h-[24px] lg:h-[28.8px]"
                    >
                        <svg
                            width="21"
                            height="35"
                            viewBox="0 0 21 35"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M15.4637 16.566C16.0753 16.8923 16.0753 17.769 15.4637 18.0952L5.17371 23.5832C4.59651 23.891 3.89941 23.4728 3.89941 22.8186L3.89941 11.8426C3.89941 11.1885 4.59652 10.7702 5.17371 11.0781L15.4637 16.566Z"
                                fill="#FF6400"
                            />
                        </svg>
                    </span>
                    <div class="flex flex-col gap-3 lg:gap-4">
                        <AtomsH4
                            class="text-base-white"
                            v-if="shouldRender(c.title)"
                        >
                            {{ renderLines(c.title) }}
                        </AtomsH4>
                        <AtomsBody3
                            class="text-base-grey"
                            v-if="shouldRender(c.text)"
                        >
                            {{ renderLines(c.text) }}
                        </AtomsBody3>
                    </div>
                </div>
            </div>
        </div>
    </li>
</template>

<script setup>
import { renderLines, shouldRender } from "~/lib/utils";

const { milestone, index } = defineProps({
    milestone: {
        type: Object,
        required: true,
    },
    index: {
        type: Number,
        required: true,
    },
});
</script>
